import React from "react";

function ListIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 14">
      <g transform="translate(-787.164 -24.311)">
        <rect
          id="Rectangle_1629"
          width="100%"
          height="6"
          rx="2"
          transform="translate(787.164 24.311)"
        />
        <rect
          id="Rectangle_1630"
          width="100%"
          height="6"
          rx="2"
          transform="translate(787.164 32.311)"
        />
      </g>
    </svg>
  );
}

export { ListIcon };
